import { useNavigate } from 'react-router-dom';
import { Button } from '@testsigma/atoms';
import notFound from '@images/404.svg';

const NotFoundComponent = () => {
  const navigate = useNavigate();
  const navigateHome = () => {
    navigate('/');
  };

  return (
    <div className='flex items-center content-between m-auto basis-full w-3/4 h-full'>
      <div className='basis-7/10 m-auto'>
        <h1 className='text-[20px] font-bold'>PAGE NOT FOUND!</h1>
        <p className={'text-[14px] text-secondary-500'}>
          {`Oh no! We couldn't find the page you were looking for.`}
        </p>
        <div className='mt-[30px] flex items-center'>
          <Button onClick={navigateHome} type='primary' className='py-2 !px-6'>
            Return Home
          </Button>
        </div>
      </div>
      <div className='basis-1/2 m-auto'>
        <img src={notFound} alt='Error Page' />
      </div>
    </div>
  );
};

export default NotFoundComponent;
